<template>
  <div class="score-lookup">
    <div class="content-header">
      <h2>成绩查询</h2>
      <p>选择考试并输入姓名与身份证号查询成绩</p>
    </div>

    <div class="form">
      <label>
        考试：
        <select v-model="examId">
          <option value="">请选择</option>
          <option v-for="e in exams" :key="e.id" :value="e.id">{{ e.title }}</option>
        </select>
      </label>
      <label>
        姓名：
        <input type="text" v-model="realName" placeholder="请输入姓名" />
      </label>
      <label>
        身份证号：
        <input type="text" v-model="idNumber" placeholder="请输入身份证号" />
      </label>
      <button class="btn-primary" :disabled="!canQuery || loading" @click="query">查询</button>
    </div>

    <div v-if="loading" class="hint">查询中…</div>
    <div v-if="error" class="error">{{ error }}</div>

    <div v-if="result && result.found" class="result">
      <div class="card">
        <div>考试：{{ result.exam.title }}</div>
        <div>姓名：{{ result.real_name }}</div>
        <div>身份证号：{{ result.id_number }}</div>
        <div>成绩：<strong>{{ result.score ?? '-' }}</strong></div>
        <div>是否通过：<strong>{{ result.is_passed ? '通过' : (result.score == null ? '-' : '未通过') }}</strong></div>
        <div>提交时间：{{ formatDate(result.submit_time) }}</div>
        <div style="margin-top:8px;">
          <button class="btn-primary" @click="downloadMyReport">下载成绩单</button>
        </div>
      </div>
    </div>
    <div v-else-if="result && !result.found" class="hint">{{ result.message || '未找到成绩记录' }}</div>
  </div>
</template>

<script>
export default {
  name: 'ScoreLookup',
  data() {
    return {
      exams: [],
      examId: '',
      realName: '',
      idNumber: '',
      loading: false,
      error: '',
      result: null,
    }
  },
  mounted() {
    this.fetchExams()
  },
  computed: {
    canQuery() { return this.examId && this.realName && this.idNumber }
  },
  methods: {
    async fetchExams() {
      try {
        const res = await fetch('/api/exam/exams/')
        const data = await res.json()
        this.exams = Array.isArray(data) ? data : (data?.results || [])
      } catch (e) {
        this.exams = []
      }
    },
    async query() {
      this.loading = true
      this.error = ''
      this.result = null
      try {
        const params = new URLSearchParams({ exam_id: String(this.examId), real_name: this.realName.trim(), id_number: this.idNumber.trim() }).toString()
        const res = await fetch(`/api/exam/scores/lookup/?${params}`)
        if (!res.ok) throw new Error('查询失败')
        this.result = await res.json()
      } catch (e) {
        this.error = e?.message || '查询失败'
      } finally {
        this.loading = false
      }
    },
    async downloadMyReport() {
      try {
        const params = new URLSearchParams({ exam_id: String(this.examId) }).toString()
        const res = await fetch(`/api/exam/scores/my/report/?${params}`)
        if (!res.ok) throw new Error('下载失败')
        const blob = await res.blob()
        const a = document.createElement('a')
        const url = URL.createObjectURL(blob)
        a.href = url
        const title = (this.exams.find(e => String(e.id) === String(this.examId))?.title) || '成绩单'
        const nameSafe = String(title).replace(/[^a-zA-Z0-9\u4e00-\u9fa5_-]+/g, '_')
        a.download = `我的成绩单_${nameSafe}.xlsx`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      } catch (e) {
        this.error = e?.message || '下载失败'
      }
    },
    formatDate(d) {
      if (!d) return '-'
      try {
        const dt = new Date(d)
        if (isNaN(dt.getTime())) return String(d)
        return `${dt.getFullYear()}-${String(dt.getMonth()+1).padStart(2,'0')}-${String(dt.getDate()).padStart(2,'0')} ${String(dt.getHours()).padStart(2,'0')}:${String(dt.getMinutes()).padStart(2,'0')}`
      } catch { return String(d) }
    }
  }
}
</script>

<style scoped>
.score-lookup { padding: 20px; }
.content-header { margin-bottom: 12px; }
.form { display: flex; gap: 12px; align-items: center; margin-bottom: 12px; }
.form input, .form select { height: 36px; padding: 8px 10px; border: 1px solid #e0e0e0; border-radius: 6px; }
.hint { color: #666; }
.error { color: #c00; }
.card { background: #fff; border: 1px solid #e0e0e0; border-radius: 8px; padding: 12px; }
</style>
